import React, {useEffect, useMemo} from 'react';
import { Row, Col, Form, Switch, Input, Select, Tooltip, Typography } from 'antd';
import {
    VerticalAlignTopOutlined, VerticalAlignBottomOutlined, RetweetOutlined, InfoCircleOutlined,
} from '@ant-design/icons';

const { Text } = Typography;
const { TextArea } = Input;

const GDPR_DEFAULT_TEXT =
    'I confirm with my signature that I have read, understood and accepted the conditions for the release of my data.';

// Helper that wraps any label with an info tooltip.
const labelWithInfo = (label, tooltip) => (
    <span>
    {label}
        <Tooltip title={tooltip}>
      <InfoCircleOutlined style={{ marginLeft: 8, color: '#999' }} />
    </Tooltip>
  </span>
);

const TabLeadCapture = () => {
    // grab the parent form instance and watch for changes.
    const form = Form.useFormInstance();
    const selectedProgrammePointId = Form.useWatch('SelectedProgrammePointId', form);
    const signatureEnabled = Form.useWatch('IsSignatureEnabled', form);

    useEffect(() => {
        // When signature is enabled → auto-fill text if empty
        if (signatureEnabled) {
            const current = form.getFieldValue('gdprText');

            // If empty or null → insert default text
            if (!current || current.trim() === '') {
                form.setFieldsValue({ gdprText: GDPR_DEFAULT_TEXT });
            }
        }
    }, [signatureEnabled, form]);

    /* SET for CreateLeadImmediately Switch */
    useEffect(() => {
        const current = form.getFieldValue('CreateLeadImmediately');

        // We only step on the value if it is true, but it should not be.
        if (!selectedProgrammePointId && current) {
            form.setFieldsValue({ CreateLeadImmediately: false });
        }
    }, [selectedProgrammePointId, form]);

    return (
        <>
            {/* Tab description */}
            <Row style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <Text type="secondary">
                        Configure the behaviour of scanners on devices assigned to this configuration.
                    </Text>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>

                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="IsSignatureEnabled"
                        valuePropName="checked"
                        label={labelWithInfo(
                            'Signature',
                            'Displays an input field to capture the participant\'s signature'
                        )}
                    >
                        <Switch />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="IsCameraEnabled"
                        valuePropName="checked"
                        label={labelWithInfo(
                            'Camera',
                            'Allow the built-in camera to be used as a scanner'
                        )}
                    >
                        <Switch />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="IsOfflineModeEnabled"
                        valuePropName="checked"
                        label={labelWithInfo(
                            'Offline Collect Mode',
                            'Displays a lead counter instead of the list of participants captured in the view. Captured leads are automatically synchronised with the server if there is an internet connection.'
                        )}
                    >
                        <Switch />
                    </Form.Item>
                </Col>

                {signatureEnabled && (
                    <Col xs={24}>
                        <Form.Item
                            name="gdprText"
                            label={labelWithInfo(
                                'GDPR Text',
                                'This text will appear when the signature is required.'
                            )}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter the GDPR text when Signature is enabled.'
                                }
                            ]}
                        >
                            <TextArea rows={4} placeholder="Enter GDPR text here..." />
                        </Form.Item>
                    </Col>
                )}
            </Row>
        </>
    );
};

export default TabLeadCapture;